<template>
  <!--询盘市场-->
  <div class="ab-market">
    <div class="ab-iserver-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
        <div class="ab-banner-info warp">
          <div class="ab-banner-name fontsize50" data-aos="fade-down">
            海量优质外贸询盘线索
          </div>
          <div
            class="ab-banner-desc fontsize20"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            覆盖全行业细分品类询盘数据，提供从线索获取、线索精准识别、线索分配与回收、销售跟进过程管理到市场ROI分析全流程线索管理为一体，致力于为外贸客户提供高质量、低成本的询盘线索采购服务。
          </div>
          <div class="ab-banner-btn" data-aos="fade-down" data-aos-delay="200">
            <Abbutton
              ><a
                href="https://crm.cnabke.com/#/passport/register"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                target="_blank"
                >立即试用</a
              ></Abbutton
            >
          </div>
        </div>
      </div>
    </div>
    <div data-aos="fade-down">
      <InquiryData></InquiryData>
    </div>
    <div class="qualitycustomers_1">
      <div class="warp">
        <!--优势对比-->
        <QualityCustomers></QualityCustomers>
      </div>
    </div>

    <div class="warp">
      <IndustryList></IndustryList>
    </div>

    <!--询盘小助手-->
    <div data-aos="fade-down">
      <FormHelp></FormHelp>
    </div>
  </div>
</template>

<script>
import MainNav from '@/components/MainNav.vue';
import Abbutton from '@/components/Abbutton.vue';
// import AbBlock from '@/components/AbBlock.vue';
import Features from '@/components/Features.vue';
import FormHelp from './Market/FormHelp.vue';
import InquiryData from './Market/InquiryData.vue';
import QualityCustomers from './Market/QualityCustomers.vue';
import IndustryList from './Market/IndustryList.vue';
import metaInfo from '@/metaInfo';
export default {
  metaInfo: metaInfo['imarket'],
  components: {
    MainNav,
    Abbutton,
    Features,
    FormHelp,
    InquiryData,
    QualityCustomers,
    IndustryList,
    // Competitive,
    // ServerList,
    // QuestionList,
    // CustomerList,
    // AbBlock,
  },
  data() {
    return {};
  },
};
</script>

<style lang="sass">

.ab-market .ab-banner-header .ab-banner-info{
  padding-top:80px
}
.ab-market .ab-banner-header .ab-banner-info .ab-banner-btn{
  margin-top:0px;

}
.qualitycustomers_1{
  background: #F7F8FC;
}
.ab-iserver-header {
  height:620px;
  background: url('~@/assets/images/询盘市场_banner.jpg') 100% no-repeat;
  background-size: cover;
}

.ab-market .ab-banner-header {
  width: 100%;
  height: 100%;

  .ab-banner-info{
    padding-top: 84px;
    padding-left: 148px;
    .ab-banner-name{
      height: 69px;
      font-family: AlibabaPuHuiTiM;
      color: #333646;
      line-height: 69px;
    }

    .ab-banner-desc{
      width: 549px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(51,51,51,0.4);
      line-height: 36px;
      padding-top: 27px;
      padding-bottom:50px;margin-top:0px;
    }
    .ab-banner-btn{
      width:200px;
    }
  }
}

.iserver-product-features{
  padding-top: 55px;
  padding-bottom: 164px;
  .features-list{
    padding-top: 62px;
  }
}
</style>
